import { defaultHover } from '@amelio/ui-library';

import type { Step } from '../StepItem';
import type { StepperColors } from '../types';
import type { StepBadgeProps } from '@amelio/ui-library';

interface GetComputedStatusParams {
    step: Step;
    index: number;
    activeIndex: number;
}

interface GetInteractionClassesParams {
    isClickable: boolean;
    onStepClick?: (step: Step, index: number) => void;
}

interface GetVariantParams {
    computedStatus: Step['status'];
}

interface GetLabelColorParams {
    computedStatus: Step['status'];
    colors: StepperColors;
}

const getComputedStatus = ({
    step,
    index,
    activeIndex,
}: GetComputedStatusParams): Step['status'] => {
    if (step.status) {
        return step.status;
    }
    if (index < activeIndex) {
        return 'completed';
    }
    if (index === activeIndex) {
        return 'active';
    }
    return 'upcoming';
};

const getInteractionClasses = ({
    isClickable,
    onStepClick,
}: GetInteractionClassesParams): string => {
    if (isClickable) {
        return defaultHover;
    }
    if (onStepClick) {
        return 'cursor-not-allowed';
    }
    return '';
};

const getVariant = ({
    computedStatus,
}: GetVariantParams): NonNullable<StepBadgeProps['variant']> => {
    switch (computedStatus) {
        case 'completed':
            return 'completed';
        case 'active':
            return 'primary';
        case 'error':
            return 'error';
        default:
            return 'inactive';
    }
};

const getLabelColor = ({
    computedStatus,
    colors,
}: GetLabelColorParams): StepperColors[keyof StepperColors] => {
    if (computedStatus === 'active') {
        return colors.active;
    }
    if (computedStatus === 'completed') {
        return colors.completed;
    }
    return colors.upcoming;
};

export { getComputedStatus, getInteractionClasses, getVariant, getLabelColor };
export type {
    GetComputedStatusParams,
    GetInteractionClassesParams,
    GetVariantParams,
    GetLabelColorParams,
};
